import React from 'react';
import { useTabContext } from '../context/TabContext';
import styles from '../Tabs.module.scss';
// @ts-ignore
import classNames from 'classnames';

type PropsType = {
    id?: string;
    className?: string,
    children?: React.ReactNode,
    dataCy?: string
}

const Panel = (props: PropsType) => {
    const { content } = useTabContext();

    return (
       <div 
            id={props.id}
            data-testid="tabs-panel"
            className={classNames(
                styles.panel,
                props.className
            )}
            data-cy={props.dataCy}
        >
           {content}
        </div>
    )
}

export default Panel;